var map = {
	"./eighth.png": "7f55",
	"./fifth.png": "8328",
	"./first.png": "2493",
	"./fourth.png": "37a2c",
	"./second.png": "8f1b",
	"./seventh.png": "fc4c",
	"./sixth.png": "5552",
	"./third.png": "21a8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c96a";